import { Popup } from "react-map-gl/maplibre";
import {
  Box,
  VStack,
  HStack,
  Text,
} from "@chakra-ui/react";
import { useMemo } from "react";
// @ts-ignore - Will be available after GraphQL codegen
import {
  AssetMapItem,
} from "@hydrologiq/gql-experience/graphql";
import AssetLink from "@hydrologiq/shared/asset/AssetLink";
import { CloseButton } from "@hydrologiq/shared/content/components/Button";
import Link from "@hydrologiq/shared/components/Link";
import { AlertsList } from "@hydrologiq/shared/components/alerts";
import { useIsSectionEnabled } from "@hydrologiq/shared/providers/SectionFeatures"


interface AssetPopupProps {
  asset: AssetMapItem;
  latitude: number;
  longitude: number;
  onClose: () => void;
}

function AssetPopup({ asset, latitude, longitude, onClose }: AssetPopupProps) {
  const isCustomersEnabled = useIsSectionEnabled("customers")

  // Transform alerts to the format expected by AlertsList
  const alerts = useMemo(() => {
    if (!asset.alerts?.items) {
      return [];
    }

    return asset.alerts.items.map(alert => ({
      id: alert.id,
      name: alert.name,
      type: alert.type,
      severity: alert.severity,
      status: alert.status,
      message: alert.message,
      firedAt: alert.firedAt,
    }));
  }, [asset.alerts]);
  

  

  const showCustomerSite = asset.customer && asset.site && isCustomersEnabled
  const showAlerts = asset.alerts && asset.alerts.total > 0;


  return (
    <Popup
      latitude={latitude}
      longitude={longitude}
      onClose={onClose}
      closeButton={false}
      closeOnClick={false}
      anchor="right"
      maxWidth="400px"

    >
      <Box p={3} minWidth="320px" fontFamily={"montserrat"} color="primary" fontSize="sm">
        {/* Header */}
        <HStack justify="space-between" mb={(showCustomerSite || showAlerts) ? 3 : 0}>
          <VStack align="start" gap={0}>
            <AssetLink size="lg" asset={{ id: asset.id, name: asset.name, kind: asset.kind, status: asset.status, monitoring_status: asset.monitoringStatus }} openExternal={true} />
          </VStack>
          <CloseButton onClick={onClose} />
        </HStack>

        {/* Location Info */}
        {showCustomerSite && (
          <Box mb={showAlerts ? 3 : 0}>
            {asset.customer && (
              <HStack>
                <Text>Customer:</Text>
                <Link href={`/customers/${asset.customer.id}`}>{asset.customer.name}  </Link>
              </HStack>
            )}
            {asset.customer && asset.site && (
              <HStack>
                <Text>Site:</Text>
                <Link href={`/customers/${asset.customer.id}/sites/${asset.site.id}`}>{asset.site.name}</Link>
              </HStack>
            )}
          </Box>
        )}

        {/* Alerts Section */}
        {showAlerts && (
          <AlertsList
            alerts={alerts}
            totalCount={asset.alerts?.total || 0}
            refetchQueries={["GetAssetsForMap"]}
            maxHeight="600px"
            updateNote="Resolved from map view"
          />
        )}

      </Box>
    </Popup>
  );
}

export default AssetPopup;
